import React from 'react';
import type { ParamListBase } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useSafeNavigation, useSafeRouteParams } from '@sg/garnish';

import { useTrackEffect } from '@order/Telemetry';

import { LoadingAnimation, NotFoundView } from '../../components';
import { useMenuRedirect, usePermanentRedirects } from './hooks';

export const NotFoundScreen = () => {
  const navigation =
    useSafeNavigation<NativeStackNavigationProp<ParamListBase>>();
  const routeParams = useSafeRouteParams<{ restaurantSlug?: string }>();

  useTrackEffect('app.not_found', { path: routeParams?.path });

  const hasPermanentRedirect = usePermanentRedirects({
    navigation: navigation ?? null,
    route: routeParams ?? null,
  });

  const isLoadingMenuRedirect = useMenuRedirect(hasPermanentRedirect, {
    navigation,
    restaurantSlug: routeParams?.restaurantSlug,
  });

  if (isLoadingMenuRedirect || hasPermanentRedirect) {
    return <LoadingAnimation />;
  }

  return <NotFoundView />;
};
